// extracted by mini-css-extract-plugin
export default {"container":"Gallery_container__JrNK0","top_section":"Gallery_top_section__ykhEB","img_container":"Gallery_img_container__bFW4F","bottom_section":"Gallery_bottom_section__3W++e"};